import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="catalog--bulk-select"
// Manages checkbox selection for bulk update of existing category attributes
export default class extends Controller {
  static targets = [
    "selectAll",
    "checkbox",
    "actionBar",
    "count",
    "form",
    "idsContainer",
  ]
  static values = {
    selectedLabel: { type: String, default: "{count} selected" },
  }

  toggle() {
    this.updateState()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach((cb) => (cb.checked = checked))
    this.updateState()
  }

  updateState() {
    const checked = this.checkboxTargets.filter((cb) => cb.checked)
    const total = this.checkboxTargets.length

    // Update select all checkbox
    this.selectAllTarget.checked = checked.length === total && total > 0
    this.selectAllTarget.indeterminate =
      checked.length > 0 && checked.length < total

    // Show/hide action bar
    if (checked.length > 0) {
      this.actionBarTarget.classList.remove("hidden")
      this.countTarget.textContent = this.selectedLabelValue.replace(
        "{count}",
        checked.length,
      )
    } else {
      this.actionBarTarget.classList.add("hidden")
    }

    // Sync hidden inputs for the bulk update form
    this.idsContainerTarget.innerHTML = ""
    checked.forEach((cb) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "update_ids[]"
      input.value = cb.value
      this.idsContainerTarget.appendChild(input)
    })
  }
}
